<template lang="pug">
.access-page
  img(src="@/assets/streamify-logotype-blue.svg").logotype
  CardMinimal.access-card
    template(v-if="!token")
      form(@keyup.enter.prevent="forgotPassword", @submit.prevent="forgotPassword").access-form
        h1.access-title {{ $t('login.forgot_password') }}
        p.access-description {{ $t('login.forgot_password_description') }}
        FormInput(icon="email-outline", id="email", :placeholder="$t('login.email')", type="email", :autocomplete="true", v-model="email", :value="email").site-style.m-t-4
        Button.very-blue.rounded.f-w.m-t-4(:disabled="email.length === 0 || state !== ''", @click="forgotPassword()" :icon="state === 'remembering' ? 'loading mdi-spin' : ''", tabindex="0") {{ $t('login.send') }}
      .line
      .footer-text
        p.ta-c {{ $t('login.remembered_password') }}!&nbsp;
          a(href="/login", @click.prevent="$router.push('/login')") {{ $t('login.login_here') }}
    template(v-else)
      form(@submit.prevent="changePassword").access-form
        h1.access-title {{ $t('login.change_password') }}
        p.access-description {{ $t('login.change_password_description') }}
        FormInput(icon="lock-outline", id="password", :placeholder="$t('login.choose_password')", type="password" v-model="password", :value="password").site-style.m-t-4
        Button.very-blue.rounded.f-w.m-t-4(:disabled="password.length < 8 || state !== ''", @click="changePassword()" :icon="state === 'forgetting' ? 'loading mdi-spin' : ''", tabindex="0") {{ $t('login.change_password') }}
      .line
      .footer-text
        p.ta-c {{ $t('login.remembered_password') }}!&nbsp;
          a(href="/login", @click.prevent="$router.push('/login')") {{ $t('login.login_here') }}
  a.customer-support-link(href="https://support.streamify.io")
    i.mdi.mdi-help-circle
    | {{ $t('login.support') }}
</template>

<script>

export default {
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  methods: {
    async forgotPassword() {
      const { email, state } = this;

      if (email === '' || state === 'remembering') {
        return;
      }

      this.state = 'remembering';

      await this.$store.dispatch('User/resetPassword', email);
      swal({ title: this.$t('login.password_reset'), text: this.$t('login.password_reset_text') });
      this.email = '';
      this.state = '';
    },
    async changePassword() {
      const { password, state, token } = this;

      if (password.length < 8 || state === 'forgetting') {
        return;
      }

      const result = await this.$store.dispatch('User/resetPasswordCange', { token, password });
      if (!result) {
        swal({ title: 'An error occured', text: 'For some reason we could not set your new password right now. Maybe the token expired or your password was not long enough.', icon: 'error' });
        return;
      }

      await swal({ title: this.$t('login.password_changed'), text: this.$t('login.password_changed_text') });
      this.$router.push('/login');
    },
  },
  data() {
    return {
      email: '',
      password: '',
      state: '',
    };
  },
};
</script>
